import React, { Component } from 'react';
import SingleClusterProjectionsTable from './singleClusterProjectionsTable';
import SingleClusterProjectionsLineGraph from './singleClusterProjectionsLineGraph';
import Tabs from 'react-accessible-tabs';

class ClusterProjections extends Component {
  render() {
    const { data, school, isMetro, chartName } = this.props;
    const tabContent = [
      {
        label: 'Chart',
        content: (
          <SingleClusterProjectionsLineGraph
            data={data}
            school={school}
            chartName={chartName}
          />
        ),
      },
      {
        label: 'Table',
        content: (
          <SingleClusterProjectionsTable
            data={data}
            school={school}
            isMetro={isMetro}
          />
        ),
      },
    ];
    const initialSelectedIndex = 0;
    return (
      <Tabs data={tabContent} initialSelectedIndex={initialSelectedIndex} />
    );
  }
}

export default ClusterProjections;



// WEBPACK FOOTER //
// ./src/components/cluster-projections.js